import { createContext, ReactNode, useMemo } from 'react';
import { useNullableContext } from 'shared/hooks/useNullableContext';
import { UpdateParams, useLocationParams } from 'shared/routing/LocationParams';

import {
  ReportsExpensesParamsDTO,
  reportsExpensesParamsSchema,
} from './ReportsDTO';

interface ReportsExpensesContext {
  params: ReportsExpensesParamsDTO;
  setParams: UpdateParams<ReportsExpensesParamsDTO>;
}

const Context = createContext<null | ReportsExpensesContext>(null);

export function useReportsExpensesContext() {
  return useNullableContext('ReportsExpenses', Context);
}

interface Props {
  children?: ReactNode;
}

export function ReportsExpensesContextProvider({ children }: Props) {
  const [params, setParams] = useLocationParams<ReportsExpensesParamsDTO>({
    zodSchema: reportsExpensesParamsSchema,
    persistName: 'ReportsExpenses',
  });

  const ctx = useMemo<ReportsExpensesContext>(
    () => ({ params, setParams }),
    [params, setParams],
  );

  return <Context.Provider value={ctx}>{children}</Context.Provider>;
}
